import { Injectable } from '@angular/core';
import { App, ViewController } from 'ionic-angular';
import { API } from '../services/api';
import { LocalStorageService } from '../services/localStorage.service';
import { CheckVersion } from './checkVersion';
import { FeatureFlags } from './featureFlags';
import { Settings } from './settings.service';
import { Utils } from './Utils';

@Injectable()
export class InitAppService {

  viewCtrl: ViewController = null;

  constructor(private fFlags: FeatureFlags,
              private localStorage: LocalStorageService,
              private app: App,
              private checkVersion: CheckVersion,
              private api: API,
              private utils: Utils,
              private settings: Settings,
  ) {

  }

  checkVersionAndPoliciesAndLoadSettingsApp(viewCtrl: ViewController) {    
    if (this.utils.getIsApp()) {
      this.checkVersion.getAppVersion().then(() => {
        this.checkVersion.checkAppVersion().then(response => {
          if (response == true) {
            this.initApp(viewCtrl);
          }
        }).catch(error => { });
      }).catch(error => { this.initApp(viewCtrl); });
    } else {
      this.initApp(viewCtrl);
    }
  }

  initApp(viewCtrl: ViewController) {
    this.viewCtrl = viewCtrl;
    this.localStorage.getToken().then(token => {
      if (!token) {
        // TODO: revisar. Reutilizar api.clearLocalStorageAndGoLogin().
        this.api.resetBaseUrlAPI();
        this.localStorage.setUrlBaseAPI(null);
        const options = {
          page: 'Organization',
          domain: 'null',
        };
        if (!this.fFlags.hasOrganizationPage()) {
          options.page = 'Organization';
          options.domain = (this.fFlags.SoyColevisa ? 'colevisa' : 'startupv');
        }
        this.app.getRootNavs()[0].setRoot(options.page, { domain: options.domain }).then(response => {
          this.viewCtrl.dismiss();
        });
      } else {
        this.localStorage.getUrlBaseAPI().then(response => {
          this.api.updateUrlBaseAPI(response);
          
          this.checkPoliciesUse();
        });
      }
    });
  }

  checkPoliciesUse() {
    this.api.checkTermOfUse().then(response => {
      if (response.accept_terms != null && response.accept_terms == false) {
        this.app.getRootNavs()[0].setRoot('PoliciesUse', {
          termId: response.terms_of_use.id,
          type: response.type,
          url: response.terms_of_use.url,
          login: false,
        })
          .then(response => {
            this.viewCtrl.dismiss();
          });
      } else {
        if (this.fFlags.DiningRooms) {
          this.app.getRootNavs()[0].setRoot('TabsPage').then(response => {
            this.viewCtrl.dismiss();
          });
        } else {
          this.settings.loadSettings(this.app.getRootNavs()[0], false, this.viewCtrl);
        }
      }
    }).catch(error => {
      if (this.fFlags.DiningRooms) {
        this.app.getRootNavs()[0].setRoot('TabsPage').then(response => {
          this.viewCtrl.dismiss();
        });
      } else {
        this.settings.loadSettings(this.app.getRootNavs()[0], false, this.viewCtrl);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/initApp.service.ts